export const ELLIPSIS_STYLE = {
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
};

export const GOOGLE_DEFAULT_SCOPE = 'email profile';
export const GOOGLE_DRIVE_SCOPE = 'https://www.googleapis.com/auth/drive';
export const GOOGLE_GMAIL_SCOPE =
  'https://www.googleapis.com/auth/gmail.modify';
export const ORBYAI_UNKNOWN = 'OrbyAI_Unknown';
export const IS_PROD = process.env.REACT_APP_ENV === 'production';
export const IS_DEV = process.env.REACT_APP_ENV === 'development';
export const IS_LOCAL = process.env.REACT_APP_ENV === 'local';

export const ROUTE_NAME_CREATE_ORGANIZATION = 'create-organization';

// ROWS PER PAGE AT BOTTOM OF TABLE
export const ROWS_PER_PAGE = [5, 10, 15, 20];
export const WORKFLOW_TEMPLATE_ROWS_PER_PAGE = [5, 10];
